import * as Immutable from 'seamless-immutable';
import {
  TEMPLATE_INSTANCE_FETCH_API_FULFILLED,
  TEMPLATES_FETCH_START,
  TEMPLATES_FETCH_API_FULFILLED,
  TEMPLATES_FETCH_API_REJECTED,
  TEMPLATE_CREATE_API_FULFILLED,
  TEMPLATE_UPDATE_API_FULFILLED,
  TEMPLATE_DELETE_API_FULFILLED,
  RESET_TEMPLATES_HIGHLIGHTING_ROWS,
  TEMPLATES_CLEAR_SEARCH,
  TEMPLATES_FETCH_SEARCH_API_FULFILLED
} from '../actions';

const initialState = Immutable.from({
  entitiesMap: {},
  orderedIds: [],
  pagination: {},
  highlightRowIds: [],
  loading: false,
  error: false,
  didFetchOnce: false,
  searchResults: []
});

export default (state = initialState, action) => {
  switch (action.type) {
    case TEMPLATE_INSTANCE_FETCH_API_FULFILLED:
      return state.setIn(['entitiesMap'], state.entitiesMap.merge({[action.payload.id]: action.payload}));
    case TEMPLATES_FETCH_START:
      return state.merge({loading: true, error: false});
    case TEMPLATES_FETCH_API_FULFILLED: {
      const {results, pagination} = action.payload;
      const orderedIds = [];
      const newEntities = {};
      results.forEach(template => {
        orderedIds.push(template.id);
        newEntities[template.id] = template;
      });
      const entitiesMap = {...state.entitiesMap, ...newEntities};
      return state.merge({didFetchOnce: true, entitiesMap, orderedIds, pagination, loading: false});
    }
    case TEMPLATES_FETCH_API_REJECTED: {
      return state.merge({error: true, loading: false});
    }
    case TEMPLATE_UPDATE_API_FULFILLED: {
      return state.setIn(['entitiesMap'], state.entitiesMap.merge({[action.payload.id]: action.payload}));
    }
    case TEMPLATE_CREATE_API_FULFILLED: {
      const newId = action.payload.id;
      const orderedIds = [newId, ...state.orderedIds];
      const entitiesMap = {...state.entitiesMap, [newId]: action.payload};
      const highlightRowIds = [action.payload.id];
      return state.merge({entitiesMap, orderedIds, highlightRowIds});
    }
    case TEMPLATE_DELETE_API_FULFILLED: {
      const deletedId = action.meta.id;
      const orderedIds = state.orderedIds.filter(id => id !== deletedId);
      const entitiesMap = state.entitiesMap.without(deletedId);
      return state.merge({entitiesMap, orderedIds});
    }
    case RESET_TEMPLATES_HIGHLIGHTING_ROWS: {
      return state.merge({highlightRowIds: []});
    }
    case TEMPLATES_CLEAR_SEARCH: {
      return state.merge({searchResults: []});
    }
    case TEMPLATES_FETCH_SEARCH_API_FULFILLED: {
      const {results} = action.payload;
      return state.merge({searchResults: results});
    }
    default:
      return state;
  }
};
